import MessageBox from '../message-box';
import printImage from '../../assets/ReceiptPrint.png';
import style from './style.module.scss';
import { useStore } from '../../lib/hooks/useStore';
import { ReceiptPrintServerProps } from '../../lib/typegen/receipt-print-server-props';
import { useEffect, useRef } from 'react';
import { ReceiptType } from '../../lib/typegen/receipt-type';
import ReceiptContentType from '../../lib/types/ReceiptContentType';

interface ReceiptPrintViewProps {
	receiptServerProps: ReceiptPrintServerProps;
	nextPageTarget: string;
}

export default function ReceiptPrintView({ receiptServerProps, nextPageTarget }: ReceiptPrintViewProps) {
	const {
		accountStore: { setReceiptType },
		receiptStore: { print },
		uiStore: { handleNavigation },
		configStore: { getString },
	} = useStore();

	const hasCalledPrint = useRef(false);

	useEffect(() => {
		setReceiptType(ReceiptType.Print);
	}, [setReceiptType]);

	useEffect(() => {
		if (receiptServerProps && !hasCalledPrint.current) {
			print(import.meta.env.VITE_USE_TEST_RECEIPT ? ReceiptContentType.Demo : ReceiptContentType.Standard, receiptServerProps);
			hasCalledPrint.current = true;

			setTimeout(() => {
				handleNavigation(nextPageTarget);
			}, 10000);
		}
	}, [handleNavigation, nextPageTarget, print, receiptServerProps]);

	return (
		<>
			<section className={style.section}>
				<img className={style.section__image} src={printImage} alt='Receipt' />
				<MessageBox className={style.section__message} type='info'>
					{getString('take-receipt-message')}
				</MessageBox>
			</section>
		</>
	);
}
